<template>
  <div class='EnbLink01' @mouseenter="emit(true)" @mouseleave="emit(false)" @click="$router.push(data.path)">
    <component :color="Prefes.nave.corFont" :is="data.icon"/>
    {{ data.text }}
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import StoreIcon01 from '@/components/Theme01/Icons/StoreIcon01'
import CartShopIcon01 from '@/components/Theme01/Icons/CartShopIcon01'
import LikeIcon01 from '@/components/Theme01/Icons/LikeIcon01'
import ListIcon01 from '@/components/Theme01/Icons/ListIcon01'
export default {
  name: 'EnbLink01',
  components: { StoreIcon01, CartShopIcon01, LikeIcon01, ListIcon01 },
  props: {
    data: {
      text: Object,
      default: () => ({ text: 'Link', path: '' })
    },
    showsubnave: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:showsubnave'],
  computed: {
    ...mapGetters(['Prefes'])
  },
  methods: {
    emit (bool) {
      if(this.data.text === 'Produtos') {
        this.$emit('update:showsubnave', bool)
      }
    }
  }
}
</script>

<style scoped>
.EnbLink01 {
  display: flex;
  justify-content: start;
  align-items: center;
  position: relative;
  text-align: left;
  padding-right: 5%;
}
</style>
